(function () {
    // Configs  
    var $conf = $('.js-conf');

    // Variables for post login.
    var filtersConf = {
        $modal: $('.js-filters-modal'),
        $bar: $('.js-filters-bar')
    };
    var listCtrl;
    var currentMobile;
    var $tTipSalaryFltr;

    // Var for h1 text and implementation of ellipsis plugin
    var $resultH1 = $('.js-result-h1');

    currentMobile = eeGlobal.mqDetector.isMobile();
    $tTipSalaryFltr = $('.js-ttip-salary-fltr');

    listCtrl = new ListControllerSearch({
        $conf: $conf,
        $paginationContainer: $('.js-pagination'),
        $resultsContainer: $('.js-results-container'),
        $breadCrumbContainer: $('.js-bread-crumb-wrapper'),
        filtersOptions: filtersConf
    });

    $(window).on('resize', function () {
        if (currentMobile != eeGlobal.mqDetector.isMobile()) {
            window.location = window.location;
        }
    });

    // Tooltip in salary filter
    $tTipSalaryFltr.tooltip();

    // Application for ellipsis plugin on the h1
    // TODO: Apply truncated function only when breakpoint change
    $(window).on('resize', function () {
        if (!eeGlobal.mqDetector.isMobile()) {
            $resultH1.trunk8({
                lines: 1
            });
        } else {
            $resultH1.trunk8({
                lines: 2
            });
        }
    }).trigger('resize');
})();
